import ViewContainer from './ViewContainer';

export default ViewContainer;
